<template>
  <div>样品类型</div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
